import { FC } from 'react'
import { Navigate } from 'react-router-dom'
import { authStore } from '@/store/authStore'
import { papelPrincipal } from '@/components/layout/menu'
import DashboardConsultor from './DashboardConsultor'
import DashboardLegado from './DashboardLegado'
import DashboardOperador from './DashboardOperador'
import VisaoCarteiraAdmin from './VisaoCarteiraAdmin'

/**
 * Despachante por papel (Onda 2 / A04 + A05): o consultor vê o Dashboard do Figma
 * (`DashboardConsultor`); ADMIN e GERENTE veem a Visão de Carteira (`VisaoCarteiraAdmin`,
 * que já reage ao `canalStore`); OPERADOR vê o dashboard da operação (`DashboardOperador`,
 * 11/09: fila de curadoria + funil + financeiro). O legado fica para papel desconhecido.
 *
 * A sincronização do canal global com o `canalStore` (Onda 1 / A02) vive no
 * `DashboardLegado`, que é onde o seletor importa — consultor não recorta por canal (6.7).
 *
 * P5 (AN-PP5 §1.3): o usuário "só FINANCEIRO" não tem dashboard (os dados dele são o Financeiro):
 * vai direto para `/financeiro`, sem passar por telas de consultor nem de operação.
 */
export const DashboardPage: FC = () => {
  const usuario = authStore((st) => st.usuario)
  const papel = papelPrincipal(usuario?.permissoes)
  if (papel === 'CONSULTOR' || papel === 'CONSULTOR_ONBOARDING') return <DashboardConsultor />
  if (papel === 'ADMIN' || papel === 'GERENTE') return <VisaoCarteiraAdmin />
  if (papel === 'OPERADOR') return <DashboardOperador />
  if (papel === 'FINANCEIRO') return <Navigate to="/financeiro" replace />
  return <DashboardLegado />
}

export default DashboardPage
